import { createRoot } from "react-dom/client";
import ComposerStandaloneRoot from "./ComposerStandaloneRoot.js";
const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}
const root = createRoot(container);

root.render(<ComposerStandaloneRoot />);
